import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'create-page' as const;

const argumentZod = z.object({
  title: z.string().describe('The title for the new page'),
  slug: z
    .string()
    .describe(
      'The URL slug for the new page (e.g. "about-us"). Must be unique within the site.'
    ),
  description: z
    .string()
    .optional()
    .describe('Optional SEO meta description for the page'),
  parentFolderId: z
    .string()
    .optional()
    .describe('Optional folder ID to place the page in'),
  draft: z
    .boolean()
    .optional()
    .describe(
      'Whether to create the page as a draft. Defaults to false (page is staged).'
    ),
});

export const createPageManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Create page',
  family: 'pages',
  llmTool: {
    name: toolName,
    description:
      'Creates a new page on the current site. Returns the page ID of the newly created page.',
    inputSchema: argumentZod,
  },
  type: 'server',
  // Site-scoped: resource doesn't exist yet, no per-page FGAC needed
  permission: [{resource: 'SitePage', action: 'create'}],
  confirmBeforeExecuting: true,
});

export type CreatePageArgumentType = z.infer<typeof argumentZod>;
